import React from 'react';
import { DevTool } from '@hookform/devtools';
import { Control } from 'react-hook-form';

interface ICustomReactHookFormDevTools {
    control : Control<any, any>;
}

const CustomReactHookFormDevTools = (props : ICustomReactHookFormDevTools) => {
    if (ENV_NAME !== 'production') {
        return <DevTool control={props.control} />;
    }
    else {
        return <div/>;
    }
};

export default CustomReactHookFormDevTools;